import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AirlinePerformanceService from '_services/airline-performance-service';

export const fetchAirlinePerformanceReport = createAsyncThunk(
    'airlinePerformance/fetch',
    async (params, { signal }) => {
        return await AirlinePerformanceService.getAirlinePerformanceReport(params, signal);
    }
);

const initialState = {
    data: null,
    status: 'idle',
    error: null,
};

const airlinePerformanceSlice = createSlice({
    name: 'airlinePerformance',
    initialState,
    reducers: {
        resetAirlinePerformanceReport: (state) => {
            state.data = null;
            state.status = 'idle';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAirlinePerformanceReport.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchAirlinePerformanceReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchAirlinePerformanceReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export const selectAirlinePerformanceData = (state) => state.airlinePerformance.data;
export const selectAirlinePerformanceStatus = (state) => state.airlinePerformance.status;
export const selectAirlinePerformanceError = (state) => state.airlinePerformance.error;

export const { resetAirlinePerformanceReport } = airlinePerformanceSlice.actions;

export default airlinePerformanceSlice.reducer;
